// PRODUCT PAGE TABS Desktop

function openCity(evt, cityName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(cityName).style.display = "block";
  evt.currentTarget.className += " active";
}

// Get the element with id="defaultOpen" and click on it
document.getElementById("defaultOpen").click();



// PRODUCT PAGE TABS MOBILE
function openCityTwo(evt, cityName) {
  var i, tabcontent_two, tablinks_two;
  tabcontent_two = document.getElementsByClassName("tabcontent_two");
  for (i = 0; i < tabcontent_two.length; i++) {
    tabcontent_two[i].style.display = "none";
  }
  tablinks_two = document.getElementsByClassName("tablinks_two");
  for (i = 0; i < tablinks_two.length; i++) {
    tablinks_two[i].className = tablinks_two[i].className.replace(" active", "");
  }
  document.getElementById(cityName).style.display = "block";
  evt.currentTarget.className += " active";
}

// Get the element with id="defaultOpen" and click on it
document.getElementById("defaultOpenTwo").click();